var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasserzeichen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 727.697 851.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M713.412,908.854a70.027,70.027,0,0,0,35.371-9.68,70.875,70.875,0,0,0,35.371-61.957l-.722-708.832v-.014a70.872,70.872,0,0,0-35.5-61.885,69.453,69.453,0,0,0-70.785.129L101.6,403.665a92,92,0,0,0,.057,158.373L677.97,899.131A70.007,70.007,0,0,0,713.412,908.854Zm13.4-780.412.722,708.832a14.063,14.063,0,0,1-7.063,12.369,13.8,13.8,0,0,1-14.14-.014L130.018,512.55a34.515,34.515,0,0,1-.028-59.4L705.543,116.088a13.781,13.781,0,0,1,14.168-.029,14.094,14.094,0,0,1,7.105,12.4Z",
    transform: "translate(-56.458 -56.855)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasserzeichen);
export default __webpack_public_path__ + "static/media/wasserzeichen.4d907f64f593e1dfed7157fcc86929d2.svg";
export { ForwardRef as ReactComponent };